import ProfileBanner from 'components/ProfileBanner/ProfileBanner';
import { withBeautyInsiderProps } from 'viewModel/content/BeautyInsider/withBeautyInsiderProps';

export default withBeautyInsiderProps(ProfileBanner);
